import { AxiosRequestConfig } from 'axios'
import {
  getEbillEnrollmentParams,
  getEbillProfileParams,
  getHeaderParams
} from 'helpers/requestParams'
import apiEndpoints from 'const/endPoint'
import apiRequestor from 'services/apiRequestor'
import { EbillInfo } from 'typings/ebill'
import { userAccountInfo } from 'helpers/user'
import { generateTrackingID } from 'helpers'
import {
  EBillResponse,
  GetStatementDetailsRequest,
  GetStatementDetailsResponse,
  StatementListRequest,
  StatementListResponse
} from './typings'

const eBillAPI = {
  getStatementDetails: async ({
    accessToken,
    cardType,
    pdfLocation,
    accountID
  }: GetStatementDetailsRequest): Promise<GetStatementDetailsResponse> => {
    const requestConfig: AxiosRequestConfig = {
      url: apiEndpoints.eBillStatement,
      method: 'GET',
      headers: { ...getHeaderParams(accessToken, 'GET', true) },
      params: { cardType, pdfLocation, 'cipher.accountId': accountID }
    }

    const response = await apiRequestor<GetStatementDetailsResponse>({
      requestConfig
    })

    return response.data
  },
  getStatementList: async ({
    accessToken,
    isChildAccount,
    ...data
  }: StatementListRequest): Promise<StatementListResponse> => {
    const method = 'POST'
    const headers = {
      accountType: userAccountInfo.accountType,
      sessionId: generateTrackingID(),
      ...getHeaderParams(accessToken, method, true)
    }

    const requestConfig: AxiosRequestConfig = {
      url: apiEndpoints.eBillSummary,
      method,
      headers,
      data
    }

    const response = await apiRequestor<StatementListResponse>({
      requestConfig,
      moduleType: 'USER'
    })

    return response.data
  },
  getEbillProfile: async (payload: EbillInfo): Promise<EBillResponse> => {
    const { accessToken } = payload
    const headerParams = getHeaderParams(accessToken)
    const requestConfig: AxiosRequestConfig = {
      url: apiEndpoints.ebillProfile,
      method: 'POST',
      headers: { ...headerParams },
      data: getEbillProfileParams(payload)
    }

    const response = await apiRequestor<EBillResponse>({
      requestConfig
    })

    return response.data
  },
  updateEbillEnrollment: async (payload: EbillInfo): Promise<EBillResponse> => {
    const { accessToken } = payload

    const headerParams = getHeaderParams(accessToken, '', true)

    const requestConfig: AxiosRequestConfig = {
      url: apiEndpoints.ebillEnrollment,
      method: 'POST',
      headers: { ...headerParams },
      data: getEbillEnrollmentParams(payload)
    }

    const response = await apiRequestor<EBillResponse>({
      requestConfig,
      moduleType: 'USER'
    })

    return response.data
  }
}

export default eBillAPI
